// Upload.tsx
import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface ModalProps {
  id?: string;
  title?: string;
  children?: ReactNode;
  tabIndex?: number | string;
  footer?: ReactNode;
  size?: "sm" | "lg" | "xl";
  show?: boolean;
  onHide?: () => void;
  pendingSubmitting?: boolean;
  centered?: boolean;
  backdrop?: "static" | true | false;
  keyboard?: boolean;
}

const Upload: React.FC<ModalProps> = ({
  id,
  title,
  tabIndex,
  children,
  footer,
  size,
  show = false,
  onHide,
  pendingSubmitting = false,
  centered = true,
  backdrop = "static",
  keyboard = false,
}) => {
  const dialogClass = size ? `modal-${size}` : "";

  return (
    <Modal
      id={id}
      tabIndex={tabIndex}
      show={show}
      onHide={onHide}
      centered={centered}
      backdrop={backdrop}
      keyboard={keyboard}
      dialogClassName={dialogClass}
      aria-labelledby={id ? `${id}Label` : undefined}
    >
      <Modal.Header>
        <Modal.Title id={id ? `${id}Label` : undefined}>{title}</Modal.Title>

        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
          disabled={pendingSubmitting}
        />
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default Upload;
